module.exports = __webpack_public_path__ + "static/img/siriminnov2.0bdc0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/siriminnov2.png
// module id = 9fPC
// module chunks = 48